import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { VngIconComponent } from "@vengreso/angular-components";
import { NotificationTemplate, NotificationVideoContent } from "src/app/core/models/notification.model";
import { NavigationService } from "src/app/core/core-services/services/navigation.service";
import { NotificationTemplateRenderer } from "../notification-template-renderer";

/**
 * Renders `{kind: "video", content: {title?, body?, video_url, thumbnail_url?}}`.
 * Scope decision (documented in the PR): rather than embedding a full inline
 * video player, this renders a thumbnail with a play affordance that opens
 * `video_url` in a new tab via `NavigationService.navigateToUrl` — consistent
 * with how the rest of the app opens external media (FlyLearning, dashboard
 * tutorials) and avoids pulling a player dependency into this already-large
 * feature.
 */
@Component({
  selector: "app-notification-video-renderer",
  standalone: true,
  imports: [CommonModule, VngIconComponent],
  templateUrl: "./notification-video-renderer.component.html",
  styleUrls: ["../notification-templates.scss"],
})
export class NotificationVideoRendererComponent implements NotificationTemplateRenderer {
  @Input() template!: NotificationTemplate;
  @Output() respond = new EventEmitter<Record<string, unknown>>();

  constructor(private readonly navigationService: NavigationService) {}

  private get content(): NotificationVideoContent {
    return this.template?.content as unknown as NotificationVideoContent;
  }

  get title(): string | undefined {
    return this.content?.title;
  }

  get body(): string | undefined {
    return this.content?.body;
  }

  get thumbnailUrl(): string | undefined {
    return this.content?.thumbnail_url;
  }

  open(): void {
    if (this.content?.video_url) {
      this.navigationService.navigateToUrl(this.content.video_url);
    }
  }
}
